export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  // TEMP: tawk.to temporarily disabled. Remove the return below to
  // re-enable the chat widget.
  return;

  /* eslint-disable no-unreachable */
  (window as any).Tawk_API = (window as any).Tawk_API || {};
  (window as any).Tawk_LoadStart = new Date();

  const isMobile = () => window.innerWidth < 768;

  // Desktop: custom position. Mobile: hide the bubble (opened via "Hulp" button).
  (window as any).Tawk_API.customStyle = {
    visibility: {
      desktop: {
        xOffset: 10,
        yOffset: 15,
        position: "br",
      },
    },
  };

  // onLoad: fires on first load
  (window as any).Tawk_API.onLoad = function () {
    if (isMobile()) {
      (window as any).Tawk_API.hideWidget();
    }
  };

  if (document.querySelector('script[data-tawk="true"]')) {
    // Script already loaded (SPA navigation) — call directly if API is ready
    if (isMobile() && (window as any).Tawk_API?.hideWidget) {
      (window as any).Tawk_API.hideWidget();
    }
    return;
  }

  const s1 = document.createElement("script");
  s1.async = true;
  s1.src = "https://embed.tawk.to/696e06d8687ba6197fc02604/1jfaslfdo";
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");
  s1.setAttribute("data-tawk", "true");

  document.head.appendChild(s1);
  /* eslint-enable no-unreachable */
});
